import React from 'react';
import { trustStats } from '../data/landingContent';
import { Container } from './Container';
export function TrustStrip() {
  return <section aria-label="What the bundle includes" className="bg-cream pb-12 sm:pb-16" data-id="element-207" data-mp="2o4cc2h8e7464">
      <Container data-id="element-208" data-mp="2jbrkzngvf56a">
        <dl className="grid grid-cols-2 overflow-hidden rounded-2xl border border-line bg-white lg:grid-cols-4" data-id="element-209" data-mp="2jb9fs1c8dgm8">
          {trustStats.map((stat, i) => <div key={stat.label} className={`flex flex-col-reverse items-center border-line px-3 py-7 text-center sm:py-8 ${i % 2 === 1 ? 'border-l' : ''} ${i > 1 ? 'border-t lg:border-t-0' : ''} ${i === 2 ? 'lg:border-l' : ''}`} data-id="element-210" data-mp="2aco1wjhpeprs" data-mpi={i}>
              <dt className="mt-2 text-[10px] font-bold uppercase tracking-[0.18em] text-muted sm:text-[11px]" data-id="element-211" data-mp="1wcwig38f4h6e">{stat.label}</dt>
              <dd className="font-condensed text-[32px] font-extrabold leading-none text-navy sm:text-[46px] lg:text-[52px]" data-id="element-212" data-mp="3ur7xsupdzczl">{stat.value}</dd>
            </div>)}
        </dl>
      </Container>
    </section>;
}